import { post } from '@/common/utils/useRequest';
import { Info } from '@/types/global'
import { defineStore } from 'pinia'

export const useUserStore = defineStore('counter', {
	state: () => ({
		token: "",
		userInfo: {} as Info,
		isChina: false,
		isOpenScreenFull: false,
		language: localStorage.getItem('lang') || "zh"
	}),
	actions: {
		init() {
			this.token = localStorage.getItem("user-token") || ""
			try {
				const user: Info = JSON.parse(localStorage.getItem("userInfo") || '{}') || {};
				this.userInfo = user;
			} catch (error) { console.debug(error) }
		},
		async getUserInfo() {
			if (!localStorage.getItem("user-token")) return;
			const res: any = await post("5c78c4772da97", {})
			this.saveUserInfo(res.data)
		},
		saveToken(token: string) {
			this.token = token;
			localStorage.setItem("user-token", token)
		},
		saveUserInfo(user: any) {
			this.userInfo = user || {};
			localStorage.setItem("userInfo", JSON.stringify(user))
		},
		loginOut() {
			this.token = "";
			this.userInfo = {};
			localStorage.removeItem('user-token')
			localStorage.removeItem('userInfo')
		},
		/** 设置地域（国内、国外） */
		setIsChina() {
			this.isChina = true;
		},
	}
})